export default __webpack_public_path__ + "static/media/settings.ca24fcc8.jpg";